module.exports = __webpack_public_path__ + "static/media/threeStar.7d652adf.png";